import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { NativeElement2p8z5z0r9meck as NativeElement } from '../NativeElement.commonHtml.mjs';
import { WordBreak_Normal_getInstance3as0xde97pocm as WordBreak_Normal_getInstance } from '../../models/data.mjs';
import { get_theme90wn9glxu60a as get_theme } from '../Element.ext.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function applyAlign($this, value) {
  var tmp0 = $this.native_1.style_1;
  var tmp;
  switch (value.ordinal_1) {
    case 0:
      tmp = 'start';
      break;
    case 1:
      tmp = 'center';
      break;
    case 2:
      tmp = 'end';
      break;
    case 3:
      tmp = 'justify';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  // Inline function 'com.lightningkite.kiteui.views.textAlign' call
  var value_0 = tmp;
  tmp0.native_1.textAlign = value_0;
}
var TextViewClass;
function TextView() {
  if (TextViewClass === VOID) {
    class $ extends NativeElement() {
      constructor(context) {
        super(context);
        this.native_1.tag_1 = 'p';
        this.native_1.set_content_i5lrjv_k$('\xA0');
        this._align_1 = null;
        this.ellipsis_1 = true;
        this.wraps_1 = true;
        this.wordBreak_1 = WordBreak_Normal_getInstance();
        this.lineClamp_1 = null;
      }
      get_driverValue_yh5neo_k$() {
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp0_elvis_lhs = this.native_1.content_1;
        return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
      }
      set_align_ypalx0_k$(value) {
        this._align_1 = value;
        applyAlign(this, value == null ? get_theme(this).font_1.align_1 : value);
      }
      set_ellipsis_rhzl3b_k$(value) {
        this.ellipsis_1 = value;
        var tmp0 = this.native_1.style_1;
        // Inline function 'com.lightningkite.kiteui.views.textOverflow' call
        var value_0 = value ? 'ellipsis' : 'clip';
        tmp0.native_1.textOverflow = value_0;
        if (value) {
          this.native_1.setStyleProperty_wavvb3_k$('overflow', 'hidden');
        } else {
          this.native_1.setStyleProperty_wavvb3_k$('overflow', null);
        }
      }
      set_wraps_9wisy1_k$(value) {
        this.wraps_1 = value;
        this.native_1.setStyleProperty_wavvb3_k$('text-wrap', value ? 'wrap' : 'nowrap');
        this.native_1.setStyleProperty_wavvb3_k$('text-wrap-mode', value ? 'wrap' : 'nowrap');
      }
      nativeApplyTheme_6heplg_k$(theme) {
        super.nativeApplyTheme_6heplg_k$(theme);
        var tmp0_elvis_lhs = this._align_1;
        applyAlign(this, tmp0_elvis_lhs == null ? theme.theme_1.font_1.align_1 : tmp0_elvis_lhs);
      }
    }
    initMetadataForClass($, 'TextView');
    TextViewClass = $;
  }
  return TextViewClass;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return constructCallableReference(() => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.native_1.content_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  }, 0, 0, 92, VOID, [p0]);
}
function TextView$_set_content_$ref_pketfb(p0) {
  return constructCallableReference((p0_0) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.native_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(p0_0) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = p0_0;
    }
    tmp.set_content_i5lrjv_k$(tmp_0);
    return Unit_instance;
  }, 1, 0, 93, VOID, [p0]);
}
//region block: exports
export {
  TextView as TextViewe6rp77b08kos,
  TextView$_get_content_$ref_4pzcwl as TextView$_get_content_$ref_4pzcwl16uunx6j4t5r9,
  TextView$_set_content_$ref_pketfb as TextView$_set_content_$ref_pketfb3nnz1ag2pn6vb,
};
//endregion

//# sourceMappingURL=TextView.commonHtml.mjs.map
